import { render } from "./Osi.vue?vue&type=template&id=d913f01c"
import script from "./Osi.vue?vue&type=script&lang=js"
export * from "./Osi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__